module.exports = __webpack_public_path__ + "e2463d78a6ca388a395cfc1d6e9e5777.svg";